import { render } from "./ProjectDetail.vue?vue&type=template&id=57f8cbd6&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=57f8cbd6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f8cbd6"],['__file',"src/views/h5/luqiao/project/project/ProjectDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57f8cbd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57f8cbd6', __exports__)) {
    api.reload('57f8cbd6', __exports__)
  }
  
  module.hot.accept("./ProjectDetail.vue?vue&type=template&id=57f8cbd6&scoped=true", () => {
    api.rerender('57f8cbd6', render)
  })

}


export default __exports__